import { Button, Flex } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { isStripeConnectedSelector, isStripeExpressAccountSelector, getStripeDashboardLink, stripeConnect, stripeDisconnect } from "store/user"
import { toaster } from "components/common/Toast"
import { spacings } from "themes/variables"

export const StripeActionButtons = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isStripeConnected = useSelector(isStripeConnectedSelector)
  const isStripeExpressAccount = useSelector(isStripeExpressAccountSelector)
  const [isDashboardLinkLoading, setIsDashboardLinkLoading] = useState(false)
  const connectStripeAccount = () => dispatch((dispatch) => stripeConnect(dispatch))
  const disConnectStripeAccount = () => dispatch(stripeDisconnect())

  const openStripeDashboard = async () => {
    // Open the tab synchronously on the click, before the await — otherwise the browser's
    // popup blocker treats the later window.open (after the network round-trip) as not
    // user-initiated and silently drops it.
    const dashboardTab = window.open("", "_blank")
    setIsDashboardLinkLoading(true)
    try {
      const { url } = await dispatch(getStripeDashboardLink())
      if (dashboardTab) dashboardTab.location.href = url
    } catch (error) {
      dashboardTab?.close()
      toaster.error(error?.data?.errors?.base?.[0] || t("pro.personal_info.stripe.dashboard_link_error"))
    } finally {
      setIsDashboardLinkLoading(false)
    }
  }

  if (!isStripeConnected) {
    return (
      <Button className="pr-l pl-l" color="primary" variant="solid" size="large" onClick={connectStripeAccount}>
        {t("pro.personal_info.stripe.connect")}
      </Button>
    )
  }

  return (
    <Flex gap={spacings.S}>
      {isStripeExpressAccount && (
        <Button className="pr-l pl-l" variant="outlined" color="primary" size="large" loading={isDashboardLinkLoading} onClick={openStripeDashboard}>
          {t("pro.personal_info.stripe.dashboard_link")}
        </Button>
      )}
      <Button className="pr-l pl-l" color="primary" variant="solid" size="large" onClick={disConnectStripeAccount}>
        {t("global.disconnect")}
      </Button>
    </Flex>
  )
}
